"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_EXIT_ERROR_STATUS = exports.SERVICE_EXIT_OK_STATUS = void 0;
exports.SERVICE_EXIT_OK_STATUS = 0;
exports.SERVICE_EXIT_ERROR_STATUS = 1;
//# sourceMappingURL=service.js.map